export default "/images/ethereum__qr_code.png";